<template>
  <div class="top-bg">
    <div class="index-con">
      <p>FIFS & ISNFF 2024：Food4Future</p>
    </div>
    <div class="navbg">
      <div class="nav">
        <div class="nav-lists-pc" v-for="(item, index) in navList" :key="index">
          <div @click.stop="toOther(item, index)" :class="current == item.url ? 'active' : ''" v-if="item.url != 'sb'"
            class="nav-list-pc">
            {{ item.text }}
          </div>
          <div class="nav-list-pc" :class="current == '/travel' ||
            current == '/visa' ||
            current == '/traveltwo' ||
            current == '/hotel'
            ? 'active'
            : ''
            " v-else>
            <p @click.stop="
              twoShow = true;
            item.active = true;
            ">
              {{ item.text }}
            </p>

            <div v-if="twoShow">
              <div class="nav-list-children" v-if="item.active">
                <p :class="current == itm.url ? 'active' : ''" @click.stop="toOther(itm, ind)"
                  v-for="(itm, ind) in item.children" :key="ind">
                  {{ itm.text }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="index != navList.length - 1" class="line"></div>
        </div>
        <div class="nav-lists-pc" v-if="currentText == 'English'">
          <div @click.stop="toOther({ text: '中文', url: '/sponsors' }, 11)"
            :class="current == '/sponsors' ? 'active' : ''" class="nav-list-pc">
            中文
          </div>
        </div>
        <div class="nav-lists-pc" v-if="currentText == '中文'">
          <div @click.stop="toOther({ text: 'English', url: '/' }, 11)" :class="current == '/' ? 'active' : ''"
            class="nav-list-pc">
            English
          </div>
        </div>
      </div>
    </div>
    <div class="h5-menu">
      <i class="el-icon-s-unfold" @click.stop="h5show = true"></i>
      <div class="h5-nav" v-if="h5show" @click.stop="h5show = true">
        <p class="h5-title" @click.stop="h5show = false">
          <i class="el-icon-close"></i>
        </p>
        <div v-for="(item, index) in navList" :key="index + 'a'">
          <p v-if="item.url != 'sb'" :class="current == item.url ? 'active' : ''" @click.stop="toOther(item, index)">
            {{ item.text }}
          </p>
          <div v-else>
            <p :key="ind" v-for="(itm, ind) in item.children" :class="current == itm.url ? 'active' : ''"
              @click.stop="toOther(itm, itm)">
              <b>·</b> {{ itm.text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      twoShow: false,
      h5show: false,
      current: "/",
      currentText: "English",
      navList: [
        {
          text: "Home",
          url: "/",
        },
        {
          text: "Organizers ▼",
          url: "sb",
          active: false,
          children: [
            {
              text: "Co-hosts",
              url: "/organizing",
            },
            {
              text: "Co-organizers",
              url: "/local",
            },
            {
              text: "Supporting Publication",
              url: "/supporting",
            },
          ],
        },
        {
          text: "Committees",
          url: "/committee1",
        },
        {
          text: "Speakers",
          url: "/committee",
        },
        // {
        //   text: "Call For Papers",
        //   // url: "/session",
        //   url: "/submissions",
        // },
        {
          text: "Registration ▼",
          url: "sb",
          active: false,
          children: [
            {
              text: "Register",
              url: "/register",
            },
            {
              text: "Registration Fee",
              url: "/visa",
            },
            {
              text: "Visa Application",
              url: "/hotel",
            },

          ],
        },
        {
          text: "Call For Abstracts",
          url: "/submissions",
        },
        {
          text: "Awards",
          url: "/Awards",
        },
        {
          text: "Program",
          url: "/program",
        },

        {
          text: " Accommodation▼ ",
          url: "sb",
          active: false,
          children: [
            {
              text: "Accommodation",
              url: "/accommodation",
              // a: "https://www.worldhotelgrandjuna.com/",
            },
            {
              text: "Travel",
              url: "/travel",
            },
            {
              text: "Discover Wuxi",
              url: "/traveltwo",
            },
          ],
        },
        // {
        //   text: "中文",
        //   url: "/sponsors",
        // },
        // {
        //   text: "Awards",
        //   url: "/awards",
        // },
      ],
    };
  },
  watch: {
    $route: "routerChange",
  },
  mounted() {
    this.routerChange();
    var lang = window.localStorage.getItem("language");
    this.$i18n.locale = lang;
  },
  methods: {
    changeLang(con) {
      window.localStorage.setItem("language", con);
      this.$i18n.locale = con;
      console.log(this.$i18n.locale, "---------");
    },
    routerChange() {
      this.current = this.$route.path;
    },
    toOther(con, index) {
      this.navList.filter((item) => {
        if (item.children) {
          item.active = false;
        }
      });

      if (index == 11) {
        this.currentText = con.text;
      }
      this.h5show = false;
      this.twoShow = false;
      console.log(con);
      if (con.a) {
        window.open(con.a, "_blank");
      } else {
        if (con.url == "no") {
          alert("暂定");
        } else {
          if (con.url && this.current != con.url) {
            this.$router.push(con.url);
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.top-bg {
  background: #fff;

  .index-con {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 80px;
    justify-content: center;
    align-items: center;

    img {
      width: 50px;
      margin-right: 20px;
    }

    p {
      font-size: 30px;
      font-weight: 600;
    }
  }

  .navbg {
    width: 100%;
    z-index: 99999;
    height: 70px;
    // background-color: #0e9bad;
    background-color: #28d6ec;
    display: flex;
    justify-content: center;
  }

  .nav {
    color: rgba(255, 255, 255, 0.9);
    height: 70px;
    line-height: 70px;
    cursor: pointer;
    width: 1200px;
    display: flex;
    justify-content: space-between;
  }

  .nav-list-pc {
    font-size: 15px;
    font-weight: 600;
    padding: 0 16px;
    flex: 1;
    text-align: center;
    position: relative;
    z-index: 99999;
  }

  .nav-list-children {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    text-align: center;
    background: #28d6ec;
    width: 140px;
  }

  .nav-list-children p {
    cursor: pointer;
    font-size: 14px;
    width: 100%;
    height: 50px;
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #fff;
  }

  .nav-list-children .active {
    background: #0e9bad;
    transition: 0.3s all;
  }

  .nav .nav-lists-pc {
    position: relative;
    box-sizing: border-box;
    line-height: 70px;
    display: flex;
    align-items: center;
    flex: 1;
    cursor: pointer;
    font-size: 16px;
    transition: 0.3s all;
    font-weight: 600;
    white-space: nowrap;
  }

  .nav-list-pc:hover::after {
    content: "";
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3px;
    background: #fff;
    position: absolute;
  }

  .nav span::after {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 20px;
    background: rgba(255, 255, 255, 0.7);
    content: "";
  }

  .nav span:nth-of-type(1)::after {
    content: none;
  }

  .nav span:hover {
    background: #117683;
  }

  .h5-menu {
    text-align: right;
    padding: 10px;
    box-sizing: border-box;
    display: none;
    position: relative;
  }

  .el-icon-s-unfold {
    font-size: 24px;
    color: #0e9bad;
  }
}

.index {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .top-bg {
    min-height: 40px;
    height: 80px;

    .index-con {
      width: 100%;
      height: 40px;

      p {
        font-size: 18px;
      }
    }

    .h5-menu {
      position: fixed;
      top: 40px;
      left: 0;
      width: 100vw;
      height: 40px;
      display: block;
      background: #8cd1f9;
      z-index: 9999;
    }
  }

  .footer-right img {
    width: 100%;
    height: auto;
  }

  .top-bg .navbg {
    display: none;
  }

  .h5-nav {
    position: absolute;
    background: #fff;
    z-index: 999;
    top: 100%;
    border: 1px solid #ddd;
    box-shadow: 3px 3px 4px #ddd;
    right: 10px;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
  }

  .h5-menu .el-icon-close {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 24px;
  }

  .h5-title {
    text-align: right;
    border-bottom: 0;
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .h5-nav p {
    height: 36px;
    display: flex;
    border-bottom: 1px dashed #eee;
    align-items: center;
  }

  .h5-nav p.active {
    color: #117683;
    font-weight: 600;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue